var PushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
let ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
const ShareUtil = require("../utils/ShareUtil")
var WinPanelEvent = require("clover/panel/WinPanel")[2]
var StrategyFlauntPanel = xClass("StrategyFlauntPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/level_flaunt_level_flaunt.csb")
})
StrategyFlauntPanel.resources = [
    "cocos/level_flaunt_bubblebox_prompt.csb",
    "cocos/level_flaunt_button_green_flaunt.csb",
    "cocos/level_flaunt_level_flaunt.csb",
    "cocos/level_flaunt_level_num.csb",
    "cocos/level_flaunt.plist",
    "font/zzgftongxin_40_greenstroke.fnt",
    "font/zzgftongxin_40_yellow_brownstroke.fnt",
]
StrategyFlauntPanel.unloadResources = [
    "cocos/level_flaunt_bubblebox_prompt.csb",
    "cocos/level_flaunt_button_green_flaunt.csb",
    "cocos/level_flaunt_level_flaunt.csb",
    "cocos/level_flaunt_level_num.csb",
    "cocos/level_flaunt.plist",
    "font/zzgftongxin_40_yellow_brownstroke.fnt",
]
StrategyFlauntPanel.load = function (callback) {
    if (window.mini && mini.getPlatform() == MiniPlatform.tt){
        StrategyFlauntPanel.resources.push("font/berlinsansfb_20_lightblueglow.fnt");
        StrategyFlauntPanel.resources.push("cocos/tiktok.plist");
        StrategyFlauntPanel.resources.push("cocos/tiktok_btn_orange_start.csb");
        StrategyFlauntPanel.resources.push("cocos/tiktok_bubblebox_prompt_node.csb");
        StrategyFlauntPanel.unloadResources.push("font/berlinsansfb_20_lightblueglow.fnt");
        StrategyFlauntPanel.unloadResources.push("cocos/tiktok.plist");
        StrategyFlauntPanel.unloadResources.push("cocos/tiktok_btn_orange_start.csb");
        StrategyFlauntPanel.unloadResources.push("cocos/tiktok_bubblebox_prompt_node.csb");
    }
    return new Promise((resolve, reject) => {
        preloadWithLoading(StrategyFlauntPanel.resources, resolve, function () {
            Toast.make(getText("error.tip.load_res_error"))
            if (callback) {
                callback()
            }
        }, function () {
            Toast.make(getText("error.tip.load_canceled"))
            if (callback) {
                callback()
            }
        })
    })
}
/**
 * 构造函数
 * @param strategyId        攻略Id
 * @param levelId           关卡编号
 * @param onCloseCallback   关闭回调
 */
StrategyFlauntPanel.prototype.ctor = function (strategyId, levelId, onCloseCallback) {
    var self = this;
    self.levelId = levelId
    self.onCloseCallback = onCloseCallback;
    self.strategyId = strategyId;
    self.bind(self);
    BasePanel.prototype.init.call(self);

    if (cc.director._runningScene.name !== "GameScene") {
        self.onClose()
        return
    }

    self.init();

    self.notHideBannerOnClose();
    self.notCheckBannerOnPopup();
    
    self.popup();
}
StrategyFlauntPanel.prototype.init = function () {
    var self = this;

    //  关卡编号
    var level = self.getChildByName("level_num")
    var levelTxt = self.getChildByName("txt")
    var levelNum = self.levelId
    var totalNum = 0
    for (var i = 0; i < 4; i++) {
        let levelSpr = level.getChildByName((4 - i).toString());
        if (levelNum > 0) {
            var num = levelNum % 10
            let sprite = cc.Sprite.createWithSpriteFrameName("level_flaunt/num" + num + ".png")
            levelSpr.setSpriteFrame(sprite.getSpriteFrame())
            let width = sprite.width;
            levelSpr.setPositionX(123 - i * 41 + (21 - width / 2))
            levelNum = (levelNum - num) / 10
            totalNum++
        } else {
            levelSpr.setVisible(false)
        }
    }
    level.setPositionX(level.getPositionX() - (4 - totalNum) * 26)
    levelTxt.setPositionX(levelTxt.getPositionX() - (4 - totalNum) * 26)

    //  炫耀按钮
    var share = UIGroupButton.create(self.getChildByName("btn"))
    ButtonPushBounceAnim.create(share)
    share.on(UIButtonEvent.Click, function () {
        self.onShareBtnClick()
    })
    var label = share.getChildByName("label")
    label.setString(getText("leveltip.showoff.btn.text"))
    label.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    label.setPositionX(label.getPositionX() + 28)
    label.setPositionY(label.getPositionY() - 3)
    //  气泡Tip
    var prompt = self.getChildByName("prompt").getChildByName("txt")
    prompt.ignoreContentAdaptWithSize(true)
    prompt.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    prompt.setPositionY(prompt.getPositionY() - 4)
    prompt.setString(getText("leveltip.showoff.btn.bubble"))
    var backgrnd = self.getChildByName("prompt").getChildByName("bubblebox1")
    var size = backgrnd.getContentSize()
    backgrnd.setContentSize(size.width + 30, size.height)
    backgrnd.setPositionX(backgrnd.getPositionX() - 12)
    self.getChildByName("txt2").setFontWeight("bold")
    self.getChildByName("txt2").setString(getText("leveltip.showoff.description.text"))

    //  关闭按钮
    var close = UIGroupButton.create(self.getChildByName("btn_close"))
    ButtonPushBounceAnim.create(close)
    close.on(UIButtonEvent.Click, function () {
        self.onCloseBtnClick()
    })

    self.setAnchorPoint(0, 0.5)

    DCAssist.dc4ShareShow("level_tip");


}
/**
 * 分享按钮点击回调
 */
StrategyFlauntPanel.prototype.onShareBtnClick = function () {
    var self = this
    if (self.isBusy)
        return;

    self.isBusy = true;

    function resetBusy() {
        self.isBusy = false;
    }
    function onSuccess(){
        Toast.make(getText("leveltip.share.success.tip"), null, resetBusy);
    }
    function onCancel() {
        if (window.mini && mini.getPlatform() == MiniPlatform.tt){
            Toast.make(getText("leveltip.share.fail.tip.douyin"), null, resetBusy);
        }else{
            Toast.make(getText("leveltip.share.fail.tip"), null, resetBusy);
        }
    }
    ShareUtil.clickStrategyShare(self.strategyId, self.levelId, onSuccess, onCancel, onCancel);
}

// 抖音加分享视频
StrategyFlauntPanel.prototype.addTTShareBtn = function (path, topics, rewards, levelId) {
    var self = this
    self.levelId = levelId;
    var shareBtn = self.getChildByName("btn");
    var pos = shareBtn.getPosition();
    shareBtn.x = pos.x - 170;
    self.getChildByName("prompt").setVisible(false);

    var shareVideoBtn = cc.CSLoader.createNode("cocos/tiktok_btn_orange_start.csb");
    self.addChild(shareVideoBtn);
    shareVideoBtn.setPosition(pos.x + 100, pos.y);
    var uiShareVideoBtn = UIGroupButton.create(shareVideoBtn);
    PushBounceAnim.create(uiShareVideoBtn);
    uiShareVideoBtn.on(UIButtonEvent.Click, function(){
        DCAssist.userTrack("douyin_video_share", "video_share_click", {click_type:"icon", current_stage:self.levelId});
        mini.shareAppMessage({
            channel: "video",
            templateId: "",
            extra: {
                videoPath: path,
                videoTopics: topics,
                hashtag_list:topics
            },
            success(){
                console.log("分享成功");
                DCAssist.userTrack("douyin_video_share", "video_share_success", {click_type:"share", current_stage:self.levelId});
                var rewardSuccess = function(evt){
                    console.log("分享领奖成功");
                    UserManager.getInstance().getDailyData().douyinShareVideoCnt = evt.data.times;
                    var rewardData =  evt.data.rewardItems;
            
                    for (const key in rewardData) {
                        var oneReward = rewardData[key];
                        UserProp.getInstance().rewardProp(oneReward.itemId, oneReward.num, null, null, ModuleName.TT_VIDEO_SHARE);
                        var pos = self.convertToWorldSpace(cc.p(0, 0));
                        var flyItemOps = table();
                        table.insert(flyItemOps, table(
                            [1, "itemId", oneReward.itemId],
                            [1, "num", oneReward.num],
                            [1, "pos", pos],
                            [1, "scale", 0.5]
                        ));
                        HomeSceneAnimation.playGetPropAnimation(flyItemOps, null, 0.15);
                    }
            
                    self.onClose();
                }
                var rewardFail = function(){
                    console.log("分享领奖失败");
                }
                var http = TTlightgameVideoShareRewardHttp.new();
                http.addEventListener(Events.kComplete, rewardSuccess);
                http.addEventListener(Events.kError, rewardFail);
                http.addEventListener(Events.kCancel, rewardFail);
                http.load();
            },
            fail(e) {
              console.log("分享失败");
            }
        });
    });

    if (rewards && rewards.length > 0){
        var bubble = cc.CSLoader.createNode("cocos/tiktok_bubblebox_prompt_node.csb");
        self.addChild(bubble);
        bubble.setPosition(pos.x + 120, pos.y - 120);
        var bubbleBox = bubble.getChildByName("bubblebox1");
        bubbleBox.width = 340;
        bubbleBox.x = -170;
        var txt = bubble.getChildByName("txt");
        txt.setString(getText("douyin_video_share_bubble"));
        txt.x = -158
        txt.y = 11

        var icon = bubble.getChildByName("icon");
        var pos1 = icon.getPosition();
        icon.removeFromParent();
        var icon = bubble.getChildByName("icon");
        var pos2 = icon.getPosition();
        icon.removeFromParent();
        bubble.getChildByName("x1000").removeFromParent();
        bubble.getChildByName("x1000").removeFromParent();

        rewards.sort((a, b)=>{
            if (b.id == "2"){
                return -1;
            }
        })
        if (rewards.length > 1){
            var icon1 = UIItemBuilder.createProp(rewards[0].id, rewards[0].num, 1)[0];
            bubble.addChild(icon1);
            icon1.setPosition(pos1.x+36, pos1.y-27);
            icon1.setScale(0.7);
            var icon2 = UIItemBuilder.createProp(rewards[1].id, rewards[1].num, 1)[0];
            bubble.addChild(icon2);
            icon2.setPosition(pos2.x+30, pos2.y-27);
            if (rewards[1].id == "2"){
                icon2.x = pos2.x-5;
            }
            icon2.setScale(0.7);
        }else{
            var icon1 = UIItemBuilder.createProp(rewards[0].id, rewards[0].num, 1)[0];
            bubble.addChild(icon1);
            icon1.setPosition(pos1.x-15, pos1.y-27);
            icon1.setScale(0.7);
        }
    }
}
/**
 * 关闭按钮点击回调
 */
StrategyFlauntPanel.prototype.onCloseBtnClick = function () {
    var self = this

    DCAssist.userTrack("levelTip", "showoff_cancel")

    self.onClose()
    if (self.onCloseCallback) {
        self.onCloseCallback()
    }
}

StrategyFlauntPanel.prototype.onCleanup = function () {
    var self = this
    unloadResList(StrategyFlauntPanel.unloadResources)
}

module.exports = StrategyFlauntPanel;
